import { createRouter, createWebHistory } from 'vue-router';
import DashboardView from '@/views/DashboardView.vue';
import LoginView from '@/views/LoginView.vue';
import LogoutView from '@/views/LogoutView.vue';
import KeyPerformanceView from '@/views/KeyPerformanceView.vue';
import DetailedKeyPerformanceView from '@/views/DetailedKeyPerformanceView.vue';
import PromoCodeView from '@/views/PromoCodeView.vue';

import { is_valid_token } from '@/router/navigationGuard.js';

const routes = [
  {
    path: '/',
    name: 'DashboardView',
    component: DashboardView,
    meta: {
      requires_auth: true,
      show_leftnav: true
    }
  },
  {
    path: '/keyperformance',
    name: 'KeyPerformanceView',
    component: KeyPerformanceView,
    meta: {
      requires_auth: true,
      show_leftnav: true
    }
  },
  {
    path: '/detailkeyperformance',
    name: 'DetailedKeyPerformanceView',
    component: DetailedKeyPerformanceView,
    meta: {
      requires_auth: true,
      show_leftnav: true
    }
  },
  {
    path: '/promocode',
    name: 'PromoCodeView',
    component: PromoCodeView,
    meta: {
      requires_auth: true,
      show_leftnav: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      requires_auth: false,
      show_leftnav: false
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutView,
    meta: {
      requires_auth: true,
      show_leftnav: true
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.requires_auth) {
    if(!is_valid_token()) {
      next({ name: 'login' });
    }
  }

  next();
});

export default router;
